export default [
  {
    path: '/pickups',
    name: 'pickup-list',
    props: true,
    component: () => import('@/views/pickups/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Liste des collectes',
      breadcrumb: [
        {
          text: 'Collectes',
          to: { name: 'pickup-list' },
        },
        {
          text: 'Liste des collectes',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'supplier'],
    },
  },
  {
    path: '/pickups/create',
    name: 'pickup-add',
    props: true,
    component: () => import('@/views/pickups/Create.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Créer une collecte',
      breadcrumb: [
        {
          text: 'Collectes',
          to: { name: 'pickup-list' },
        },
        {
          text: 'Création de collecte',
          active: true,
        },
      ],
      roles: ['supplier'],
    },
  },
  {
    path: '/pickups/edit/:id',
    name: 'pickup-edit',
    props: true,
    component: () => import('@/views/pickups/Edit.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Modifier une collecte',
      breadcrumb: [
        {
          text: 'Collectes',
          to: { name: 'pickup-list' },
        },
        {
          text: 'Modification de collecte',
          active: true,
        },
      ],
      roles: ['supplier', 'admin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/pickups/show/:id',
    name: 'pickup-show',
    props: true,
    component: () => import('@/views/pickups/Show.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Détails de la collecte',
      breadcrumb: [
        {
          text: 'Collectes',
          to: { name: 'pickup-list' },
        },
        {
          text: 'Détails de la collecte',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator', 'supplier', 'sales'],
    },
  },
]
